__turbopack_context__.v({
  "container": "-q2m6W_container",
  "container-repop": "-q2m6W_container-repop",
  "ctaButtonWrapper": "-q2m6W_ctaButtonWrapper",
  "description": "-q2m6W_description",
  "iconText": "-q2m6W_iconText",
  "receiptsWrapper": "-q2m6W_receiptsWrapper",
  "title": "-q2m6W_title",
});
